<template>
    <div class="download" v-if="loggedIn">
        <el-dropdown placement="bottom-start" @command="handleDownload">
          <span class="el-dropdown-link">
            <i class="el-icon-download"></i> Pobierz <i class="el-icon-arrow-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="pdf">PDF</el-dropdown-item>
            <el-dropdown-item command="png">PNG</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Editor from '../../../classes/Editor'

export default {
    computed: {
        ...mapGetters('user', [
            'loggedIn',
        ]),
    },
    methods: {
        async handleDownload(type, $event, force = false) {

            const loading = this.$loading({
                lock: true,
                text: `Pobieranie ${type}...`,
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })

            try {
                switch (type) {
                    case 'pdf':
                        await Editor.getPdf(force)
                    break
                    case 'png':
                        await Editor.getPng(force)
                    break
                }
            } catch (error) {
                if (error.message.includes('Failed to fetch') && error.message.includes('/fonts/')) {

                    const fontName = error.message.split('/fonts/')[1].split('/')[0]
                    const fontSource = error.message.split('Failed to fetch (url: "')[1].replace('")', '')

                    const content = `
                        Ups... Wystąpił błąd podczas generowania ${type}. Nie znaleziono źródła dla fonta: <br /><br /><b>${fontName}</b> - <a target="_blank" href="${fontSource}"><i>${fontSource}</i></a>
                    `

                    this.$alert(content, 'Błąd generowania', {
                        dangerouslyUseHTMLString: true
                    })
                } else if (error.message === 'Overflow elements') {

                    const objects = Editor.getOverflowObjects()

                    const content = `
                        Ups... Wystąpił błąd podczas generowania ${type}. Poniższe elementy wychodzą poza projekt: <br />
                        <ul>
                        ${objects.reduce((content, element) => {
                            return `
                                ${content}
                                <li>
                                    <b>${element.version}</b> - ${Editor.getObjectName(element.object)} (X: ${element.object.left}, Y: ${element.object.top})
                                </li>
                            `
                        }, '')}
                        </ul>
                        <b>Czy na pewno chcesz pobrać ${type}?</b>
                    `

                    this.$confirm(content, 'Błąd generowania', {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: 'Pobierz',
                        cancelButtonText: 'Anuluj',
                    })
                    .then(() => {
                        this.handleDownload(type, null, true)
                    })
                    .catch(() => false)
                }
                else {
                    console.log('error', error)
                    this.$alert(`Ups... Wystąpił błąd podczas generowania ${type}`, 'Błąd generowania')
                }

            } finally {
                loading.close()
            }

        },
    },
}
</script>

<style scoped>
.el-menu-item.is-disabled {
  opacity: .5;
}

.el-link,
.el-link.el-link--primary {
  margin: 0;
  font-weight: 400;
  font-size: 13px;
}

.el-dropdown-link {
  cursor: pointer;
  font-size: 13px;
}
</style>